import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { validations, SelectField } from '@unite-us/app-components';

const PreferredMethodOfContactField = ({
  field,
  forceObjectValue,
  id,
  inline,
  label,
  multiple,
  options,
  registerField,
  required,
  shouldSort,
}) => (
  <SelectField
    className="preferred-method-of-contact-field"
    id={id}
    label={label}
    labelKey="display_name"
    valueKey="value"
    options={options}
    clearable
    field={field}
    inline={inline}
    multiple={multiple}
    placeholder="Select..."
    ref={registerField}
    required={required}
    shouldSort={shouldSort}
    validations={required && validations.isRequired}
    forceObjectValue={forceObjectValue}
  />
);

PreferredMethodOfContactField.propTypes = {
  field: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  forceObjectValue: PropTypes.bool,
  label: PropTypes.string,
  multiple: PropTypes.bool,
  shouldSort: PropTypes.bool,
  options: PropTypes.array.isRequired,
  registerField: PropTypes.func,
  required: PropTypes.bool,
};

PreferredMethodOfContactField.defaultProps = {
  inline: false,
  label: 'Methods of Contact',
  multiple: false,
  shouldSort: false,
  registerField: noop,
  required: false,
  forceObjectValue: true,
};

export default PreferredMethodOfContactField;
